import React from 'react';
import PropTypes from 'prop-types';
import { PeriodTimelineBlocksLoading } from '~/modules/resourcing/common/chart/components';
import {
  useGetSmartFitResourceAvailablityHoursOptions,
  useGetSmartFitResourceAvailablityHoursOptionsByTotalHours
} from '~/modules/resourcing/hooks';
import { useMeContext } from '~/modules/me';
import ResourceAssignmentSmartFitConfirmationDialog from '../ResourceAssignmentSmartFitConfirmationDialog';
import getShowSmartMatchDialog from './useShowSmartMatchDialog';

import useStyles from './useStyles';

const ShowSmartFitDialogOrLoading = ({
  classes: classesOverrides,
  resourceUser,
  scheduleRules,
  scale,
  chartStartDate,
  createAllocationWithUserAndOverrideRules,
  closeShowSmartFitDialogOrLoading,
  projectDefaultScheduleRule,
  // new query related props
  useNewSmartFitQuery = false,
  totalAllocatedHours,
  allocationDateRange
}) => {
  const classes = useStyles({ classes: classesOverrides });
  const me = useMeContext();

  const smartFitHookOld = useGetSmartFitResourceAvailablityHoursOptions({
    userUri: resourceUser.id,
    scale,
    scheduleRules: scheduleRules.map(r => ({
      dateRange: {
        startDate: r.dateRange.startDate,
        endDate: r.dateRange.endDate
      },
      do: r.do
    })),
    skip: useNewSmartFitQuery
  });

  const smartFitHookNew = useGetSmartFitResourceAvailablityHoursOptionsByTotalHours(
    {
      userUri: resourceUser.id,
      dateRange: allocationDateRange,
      hoursPerPeriod: totalAllocatedHours,
      skip: !useNewSmartFitQuery
    }
  );

  const { isLoading, smartFitmentDetails } = useNewSmartFitQuery
    ? smartFitHookNew
    : smartFitHookOld;

  if (isLoading)
    return (
      <PeriodTimelineBlocksLoading
        classes={classes}
        scale={scale}
        chartStartDate={chartStartDate}
        scheduleRules={scheduleRules}
        projectDefaultScheduleRule={projectDefaultScheduleRule}
      />
    );

  const showSmartMatchDialog = getShowSmartMatchDialog({
    me,
    smartFitmentDetails,
    scale,
    scheduleRules,
    totalAllocatedHours,
    useNewSmartFitQuery
  });
  const { availableScheduleRulesWhatFits = [] } = smartFitmentDetails || {};

  if (!showSmartMatchDialog) {
    createAllocationWithUserAndOverrideRules(
      availableScheduleRulesWhatFits || scheduleRules
    );

    return null;
  }

  return (
    <ResourceAssignmentSmartFitConfirmationDialog
      smartFitmentDetails={smartFitmentDetails}
      scale={scale}
      scheduleRules={scheduleRules}
      resourceUser={resourceUser}
      createAllocationWithUserAndOverrideRules={
        createAllocationWithUserAndOverrideRules
      }
      closeShowSmartFitDialogOrLoading={closeShowSmartFitDialogOrLoading}
    />
  );
};

ShowSmartFitDialogOrLoading.propTypes = {
  classes: PropTypes.object,
  closeShowSmartFitDialogOrLoading: PropTypes.func,
  createAllocationWithUserAndOverrideRules: PropTypes.func,
  scale: PropTypes.string,
  resourceUser: PropTypes.object,
  chartStartDate: PropTypes.object,
  scheduleRules: PropTypes.array,
  projectDefaultScheduleRule: PropTypes.object,
  useNewSmartFitQuery: PropTypes.bool,
  totalAllocatedHours: PropTypes.number,
  allocationDateRange: PropTypes.object
};

export default ShowSmartFitDialogOrLoading;
